// Air bikes (Rogue Echo, Assault, Airdyne): arms and legs both push, and the
// watts are worked out from fan speed rather than measured, so the cycling
// VO2max estimate doesn't hold for them. Spotted by name; the bike's sheet in
// Settings can say otherwise either way. Kept on this device, by device id.

const KEY = "khronos_air_bikes";
const NAME_RE = /\becho\b|assault|air\s*bike|airdyne|attack\s*fitness|\bfan\s*bike/i;

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch {
    return {};
  }
};

export const looksLikeAirBike = (name) => NAME_RE.test(String(name || ""));

/** Whether a bike ({ id, type, name, advertisedName }) is an air bike. */
export const isAirBike = (device) => {
  if (!device || device.type !== "indoor_bike") return false;
  const chosen = read()[device.id];
  if (typeof chosen === "boolean") return chosen;
  return looksLikeAirBike(device.advertisedName) || looksLikeAirBike(device.name);
};

export const setAirBike = (id, on) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...read(), [id]: !!on }));
  } catch {
    /* storage unavailable */
  }
};
